import './Vision.scss';
import React from 'react';
// import useScript from '../../helpers/bloomerang';
// import { Helmet } from "react-helmet";
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';



// import images
import blueWaves from '../../assets/images/2026Dinner.png';
// import whitelinenbackground from '../../assets/images/whitelinenbackground.png';
// import Logo from '../../assets/images/iconlogo.png';
// import Feather from '../../assets/images/feather.png';

export default function Vision() {

    // const [show3, setShow3] = useState(false);
    // const handleClose3 = () => setShow3(false);
    // const handleShow3 = () => setShow3(true);



    // load script
    // useExternalScripts("https://s3-us-west-2.amazonaws.com/bloomerang-public-cdn/jasminerhosefoundation/.widget-js/1189888.js");

    // DINNER FORM
    // const data='<script src="https://s3-us-west-2.amazonaws.com/bloomerang-public-cdn/jasminerhosefoundation/.widget-js/1189888.js" type="text/javascript"></script>'
    // const DinnerForm = () => {
    //     useEffect(() => {
    //         // Create a script element
    //         const script = document.createElement('script');

    //         // Set the script source to the remote-widgets.js file
    //         script.src = 'https://s3-us-west-2.amazonaws.com/bloomerang-public-cdn/jasminerhosefoundation/.widget-js/1189888.js';
    //         script.async = true;

    //         // Append the script to the document body
    //         document.body.appendChild(script);

    //         // Load the DinnerForm script after the remote-widgets.js has loaded
    //         script.onload = () => {
    //             const remoteDinnerForm = document.createElement('script');
    //             remoteDinnerForm.text = `DinnerForm`;

    //             // Append the DinnerForm script to the document body
    //             document.body.appendChild(remoteDinnerForm);
    //         };
    //         // Cleanup: Remove the script elements when the component unmounts
    //         return () => {
    //             document.body.removeChild(script);
    //         };
    //     }, []);
    // };

    // useEffect(() => {
    //     const script = document.createElement('script');

    //     script.src = "http://s3-us-west-2.amazonaws.com/bloomerang-public-cdn/jasminerhosefoundation/.widget-js/1189888.js";
    //     script.type = 'text/javascript';
    //     script.crossOrigin='Anonymous';
    //     script.async = true;

    //     document.body.appendChild(script);

    //     return () => {
    //       document.body.removeChild(script);
    //     }
    //   }, []);


    // useEffect(() => {
    //     // Create a script element
    //     const script = document.createElement('script');

    //     // Set the script source to the remote-widgets.js file
    //     script.src = 'https://s3-us-west-2.amazonaws.com/bloomerang-public-cdn/jasminerhosefoundation/.widget-js/54272.js';
    //     script.async = true;

    //     // Append the script to the document body
    //     document.body.appendChild(script);

    //     // Load the RemoteCalc script after the remote-widgets.js has loaded
    //     script.onload = () => {
    //         const myDinnerForm = document.createElement('script');
    //         myDinnerForm.text = `startBloomerangLoad()`;

    //         // Append the RemoteCalc script to the document body
    //         document.body.appendChild(myDinnerForm);

    //         // Cleanup: Remove the script elements when the component unmounts
    //         return () => {
    //             document.body.removeChild(script);
    //         };
    //     },[]);
    //     return <div></div>
    // useExternalScripts('https://s3-us-west-2.amazonaws.com/bloomerang-public-cdn/jasminerhosefoundation/.widget-js/54272.js')


    // const DinnerForm =useScript('https://s3-us-west-2.amazonaws.com/bloomerang-public-cdn/jasminerhosefoundation/.widget-js/1189888.js', 'Bloomerang')



    return (
        <div className='container'
            style={{
                margin: 'auto',
                background: '#54a09d',
                backgroundImage: `url(${blueWaves})`,
                backgroundRepeat: 'no-repeat',  /* Prevents tiling */
                backgroundSize: '100% 100%',    /* Forces image to stretch to the exact edges */
                borderRadius: '20px',
                filter: 'saturate(1) brightness(1.2)',
                // padding: '100px',
                padding: 'clamp(16px, 4vw, 64px)',
                height: '100vh', // A7just as needed
                width: '100%', // Adjust as needed 
                // color: '#e6e0d9',
                marginTop: '5vh',
                marginBottom: '5vh',
            }}
        >

            <div className='container font-format ' style={{ margin: 'auto', paddingTop: '5vh' }} >

                {/* Feather Image */}
                {/* <div className='image-container'>
                    <img src={Feather} className="card-img-top, image-container" alt="feather" style={{ height: "50%", width: "50%" }} />
                </div> */}

                <h1 className='theSeasonsText' style={{ color: 'black' }}>Jasmine Rhose Foundation Vision Dinner 2026</h1>

                <div className='givingText'>
              <br />
                    <p>
                        Join us for a special evening to hear
                        first hand from founders Scott and
                        Rhose Boyer as they share ministry
                        updates, stories of transformed lives,
                        and how dreams once imagined are
                        now becoming reality for vulnerable
                        children in the Philippines. Come
                        discover the journey from small
                        beginnings to a growing vision—and
                        hear about the greater dreams still
                        waiting to unfold.
                    </p>


                    <p>
                        Dinner is complimentary. An opportunity to give will be presented. Because seating is limited, reservation is required. Adults only, please.
                        <br /> <br />
                        Please RSVP by September 1, 2026.
                    </p>
                    <br />
                    <div>
                        <b className='theSeasonsText' style={{ color: '#1F5051' }}>
                            Date and Time:
                        </b>
                        <br />
                        <p>September 11, 2026 at 6:00 pm for reception
                            <br></br>
                            Dinner will be served at 6:30pm
                        </p>

                    </div>
                    {/* <br /> */}
                    <div >
                        <b className='theSeasonsText' style={{ color: '#1F5051' }}>Address:</b>
                        <p>
                            Meridian Banquet & Conference Center
                            <br />
                            1701 W Algonquin Rd, Rolling Meadows, IL 60008
                        </p>
                    </div>
                    {/* <br /> */}
                    <div >
                        <b className='theSeasonsText' style={{ color: '#1F5051' }}> Attire: </b> <br />
                        <p>Formal Business Attire</p>
                    </div>
                    <br />

                </div>

                <b className='theSeasonsText givingText' style={{ color: '#1F5051', fontSize: '1.5rem' }}> Since seating is limited, reservation is required.</b>

                <div>
                    <br />
                </div>
            </div>

            <a href="https://v4app.fundeasy.com/events/attendance/660/event" target="_blank" rel="noopener noreferrer">
                <button className='blueSupportBtn theSeasonsText' style={{ color: 'black', textDecoration: 'none', }}> R.S.V.P </button>
            </a>

            {/* <button className='blueSupportBtn' style={{ color: 'white', textDecoration: 'none', }} onClick={handleShow3} >
                R.S.V.P

            </button> */}
            {/* <Modal show={show3} onHide={handleClose3}>
                <Modal.Header closeButton style={{ backgroundImage: `url(${whitelinenbackground})` }}>
                    <img src={Logo} style={{ width: '7rem', margin: '1px' }}></img>

                    <Modal.Title className='donateHeader' style={{ marginLeft: '20px', fontSize: '3rem', color: 'black' }}>R. S. V. P.</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ position: 'relative', overflow: 'hidden', width: '100%', height: '1200px', paddingTop: '100%', }} >
                        <iframe title='Jasmine Rhose'
                            style={{ position: 'absolute', border: '0', top: '0', left: '0', bottom: '0', right: '0', width: '100%', height: '100%', }}
                            src='https://secure.fundeasy.com/ministrysync/RegistrationManager/PublicRegistration.php?e=30098&NewReference=yes'
                        >
                        </iframe>

                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose3}>
                        Close
                    </Button>

                </Modal.Footer>


            </Modal> */}

            <br />

            <div className='givingText'>


            </div>



            <div style={{ paddingBottom: '1rem' }}>
                <br />
            </div>

            <div>


            </div>



        </div>



    );
}